import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Loading from '../parts/Loading'
import endpoints, { getBackendUrl } from '../../../endpoints';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import DOMPurify from 'dompurify';

const sourceList = [
    {value: 'contact_us', label: 'Contact Us Form'},
    {value: 'upwork', label: 'Upwork Message'},
]

export default function AutoreplyTestModal(props) {
    const [data, setData] = useState(props.data)
    
    const [email, setEmail] = useState()
    const [answer, setAnswer] = useState()
    const [source, setSource] = useState('contact_us')
    const [loading, setLoading] = useState(false)
    
    const token = useSelector((state) => state.auth.token)
    
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
    
    const makeAnswer = async () => {
        setLoading(true)
        let uri = getBackendUrl(endpoints.autoreply_test, token)
        try {
            let res = await axios.post(uri, {
                source: source, 
                content: email
            })
            setAnswer(res.data?.answer)
        } catch (e) {
            //
        }
        setLoading(false)
    }
    
    useEffect(() => {
        if (props.data == false) {
            setEmail('')
        }
    }, [props.data])
        
    return (
        <Dialog open={props.data ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="lg" >
            <DialogTitle id="alert-dialog-title">
                AI Test
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item lg={6} xs={12}>
                        <Stack spacing={2}>
                            <TextField
                                select
                                label="Email Source"
                                defaultValue="contact_us"
                                variant="filled"
                                onChange={(e) => {setSource(e.target.value)}}
                            >
                                {sourceList.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            
                            <TextField
                                fullWidth
                                label="Email Content" 
                                variant="filled"
                                multiline
                                rows={16}
                                value={email}
                                onChange={(e) => {setEmail(e.target.value)}}
                            />
                            <Button 
                                onClick={() => {makeAnswer()}}
                            >
                                Make Answer
                            </Button>
                        </Stack>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <Alert sx={{whiteSpace: 'pre-line'}}>
                            <div dangerouslySetInnerHTML={rawMarkup(answer)} />
                        </Alert>
                    </Grid>
                </Grid>
                {loading ? <Loading /> : null }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}}>CLose</Button>
            </DialogActions>
        </Dialog>
    )
}